import { PERSONAL_AREA_ROUTES, ROUTE_NAME } from 'enums/routes'
import scss from '@/utils/scss'

const { breakpoints } = scss

export const PAGES_WITHOUT_SIDEBAR_LAYOUT = [
  ROUTE_NAME.HOMEPAGE,
  ROUTE_NAME.SHARED_COMPONENTS,
  ROUTE_NAME.TERMS_OF_USE,
  ROUTE_NAME.PRIVACY,
  ROUTE_NAME.COOKIES,
  ROUTE_NAME.NEWSLETTER,
  ROUTE_NAME.FORGOT_PASSWORD,
  ROUTE_NAME.RESET_PASSWORD,
  ROUTE_NAME.REACTIVATION,
  ROUTE_NAME.AUTHOR,
  ROUTE_NAME.AUTHOR_AUTHOR,
  ROUTE_NAME.BROKERS,
  ROUTE_NAME.BECOME_AN_AUTHOR,
  ROUTE_NAME.PREMIUM,
  ...PERSONAL_AREA_ROUTES
]

/**
 * Pages that do not have sidebar as part of the layout, but have sidebar
 * content. We still need to request the sidebar content for such pages.
 */
export const SPECIAL_PAGES_WITH_SIDEBAR_CONTENT = [ROUTE_NAME.HOMEPAGE]

export const WIDGET_PAGES_BREAKPOINTS_TO_HIDE_SIDEBAR_ON = [
  breakpoints.mobile,
  breakpoints.tablet,
  breakpoints.desktopSm
]

export const DEFAULT_BREAKPOINTS_TO_HIDE_SIDEBAR_ON = [breakpoints.mobile]

export const BREAKPOINTS_TO_HIDE_SIDEBAR_ON_BY_PAGE = {
  [ROUTE_NAME.LIVE_CHARTS]: WIDGET_PAGES_BREAKPOINTS_TO_HIDE_SIDEBAR_ON,
  [ROUTE_NAME.LIVE_QUOTES]: WIDGET_PAGES_BREAKPOINTS_TO_HIDE_SIDEBAR_ON,
  [ROUTE_NAME.LIVE_QUOTES_ASSET]: WIDGET_PAGES_BREAKPOINTS_TO_HIDE_SIDEBAR_ON,
  [ROUTE_NAME.ECONOMIC_CALENDAR]: WIDGET_PAGES_BREAKPOINTS_TO_HIDE_SIDEBAR_ON
}

export const ALL_BREAKPOINTS = Object.values(breakpoints)

export const CLASS_BY_BREAKPOINT = {
  [breakpoints.mobile]: 'full-width-on-mobile',
  [breakpoints.tablet]: 'full-width-on-tablet',
  [breakpoints.desktopSm]: 'full-width-on-desktop-sm',
  [breakpoints.desktopMd]: 'full-width-on-desktop-md',
  [breakpoints.desktopLg]: 'full-width-on-desktop-lg',
  [breakpoints.aboveDesktopXl]: 'full-width-on-desktop-full-hd'
}

export const SIDEBAR_COMPONENT_SETTINGS = [
  {
    id: 'sidebar-banner-start-trading',
    component: 'SidebarBannerStartTrading'
  },
  {
    id: 'live-bytes',
    component: 'LiveBytes',
    className: 'sidebar__live-bytes'
  },
  {
    id: 'sidebar-banner-top',
    component: 'SidebarBannerTop'
  },
  {
    id: 'premium-banner',
    component: 'PremiumBanner'
  },
  {
    id: 'sidebar-top-brokers',
    component: 'SidebarTopBrokers'
  },
  {
    id: 'sidebar-must-read',
    component: 'SidebarMustRead',
    className: 'sidebar__must-read'
  },
  {
    id: 'sidebar-banner-middle',
    component: 'SidebarBannerMiddle'
  }
]

export const SIDEBAR_COMPONENT = {
  SIDEBAR_BANNER_START_TRADING: 'sidebar-banner-start-trading',
  LIVE_BYTES: 'live-bytes',
  PREMIUM_BANNER: 'premium-banner',
  SIDEBAR_BANNER_TOP: 'sidebar-banner-top',
  SIDEBAR_TOP_BROKERS: 'sidebar-top-brokers',
  SIDEBAR_MUST_READ: 'sidebar-must-read',
  SIDEBAR_BANNER_MIDDLE: 'sidebar-banner-middle'
}

export const DEFAULT_SIDEBAR_COMPONENTS = [
  SIDEBAR_COMPONENT.SIDEBAR_BANNER_START_TRADING,
  SIDEBAR_COMPONENT.LIVE_BYTES,
  SIDEBAR_COMPONENT.PREMIUM_BANNER,
  SIDEBAR_COMPONENT.SIDEBAR_BANNER_TOP,
  SIDEBAR_COMPONENT.SIDEBAR_TOP_BROKERS,
  SIDEBAR_COMPONENT.SIDEBAR_MUST_READ,
  SIDEBAR_COMPONENT.SIDEBAR_BANNER_MIDDLE
]

export const SIDEBAR_COMPONENTS_ROUTE_CONFIG = {
  [ROUTE_NAME.ABOUT]: [
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_START_TRADING,
    SIDEBAR_COMPONENT.PREMIUM_BANNER,
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_TOP,
    SIDEBAR_COMPONENT.SIDEBAR_TOP_BROKERS,
    SIDEBAR_COMPONENT.SIDEBAR_MUST_READ,
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_MIDDLE
  ],
  [ROUTE_NAME.TERMS]: [
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_START_TRADING,
    SIDEBAR_COMPONENT.PREMIUM_BANNER,
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_TOP,
    SIDEBAR_COMPONENT.SIDEBAR_TOP_BROKERS,
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_MIDDLE
  ],
  [ROUTE_NAME.TERMS_LETTER]: [
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_START_TRADING,
    SIDEBAR_COMPONENT.PREMIUM_BANNER,
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_TOP,
    SIDEBAR_COMPONENT.SIDEBAR_TOP_BROKERS,
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_MIDDLE
  ],
  [ROUTE_NAME.TERMS_LETTER_TERM]: [
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_START_TRADING,
    SIDEBAR_COMPONENT.PREMIUM_BANNER,
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_TOP,
    SIDEBAR_COMPONENT.SIDEBAR_TOP_BROKERS,
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_MIDDLE
  ],
  [ROUTE_NAME.TERMS_SEARCH_RESULTS]: [
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_START_TRADING,
    SIDEBAR_COMPONENT.PREMIUM_BANNER,
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_TOP,
    SIDEBAR_COMPONENT.SIDEBAR_TOP_BROKERS,
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_MIDDLE
  ],
  [ROUTE_NAME.LIVE_QUOTES]: [
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_START_TRADING,
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_TOP,
    SIDEBAR_COMPONENT.SIDEBAR_TOP_BROKERS,
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_MIDDLE
  ],
  [ROUTE_NAME.DIRECTORY_COMPANY]: [
    SIDEBAR_COMPONENT.LIVE_BYTES,
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_TOP
  ],
  [ROUTE_NAME.SEARCH_RESULTS]: [
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_START_TRADING,
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_TOP,
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_MIDDLE
  ],
  [ROUTE_NAME.CONTACT_US]: [
    SIDEBAR_COMPONENT.SIDEBAR_BANNER_TOP,
    SIDEBAR_COMPONENT.PREMIUM_BANNER
  ]
}
